import { render } from "./FeedbackButton.vue?vue&type=template&id=f76000b2&scoped=true"
import script from "./FeedbackButton.vue?vue&type=script&lang=js"
export * from "./FeedbackButton.vue?vue&type=script&lang=js"

import "./FeedbackButton.vue?vue&type=style&index=0&id=f76000b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f76000b2"]])

export default __exports__